"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Password = void 0;
const effect_1 = require("effect");
exports.Password = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[\u0020-\u007e]*$/, {
    message: () => 'The password contains invalid characters.',
}), effect_1.Schema.minLength(8, { message: () => 'Must contain at least 8 characters.' }), effect_1.Schema.maxLength(63, { message: () => 'Must contain at most 63 characters.' })).annotations({
    identifier: 'Network.WiFi.Wpa2.Password',
});
//# sourceMappingURL=wpa2.js.map